import React from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaLightbulb, FaCogs } from 'react-icons/fa';
import { Col, Row } from 'antd';
import src1 from "../style/thermal_img/07-Thermal-Engineer.jpg";

// import bgImage from '../style/images/why-catapult-bg.jpg';

const features = [
  {
    icon: <FaMapMarkerAlt size={30} />,
    title: 'Venue Finalisation',
    description:
      'We scout and secure unique, undiscovered venues that perfectly match your event vision. Our network ensures you get the ideal location every time.',
  },
  {
    icon: <FaLightbulb size={30} />,
    title: 'Event Conceptualisation',
    description:
      'From invitations to decor and guest management, we co-create every detail with you for a personalized and unforgettable event journey.',
  },
  {
    icon: <FaCogs size={30} />,
    title: 'Event Production',
    description:
      'Lights, sound, crew, design, tech – we handle every production detail so you can relax and enjoy your event stress-free.',
  },
];


const WhyCatapult = () => {
   const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };
  return (
    //  <section className="why-catapult" id="why">
    //   <div className="overlay"></div>
    //   <div className="container">
    //     <motion.h2
    //       className="why-title"
    //       initial={{ opacity: 0, y: 40 }}
    //       whileInView={{ opacity: 1, y: 0 }}
    //       transition={{ duration: 0.6 }}
    //       viewport={{ once: true }}
    //     >
    //       Why Catapult Media Work?
    //     </motion.h2>
    //     <motion.p
    //       className="why-intro"
    //       initial={{ opacity: 0, y: 30 }}
    //       whileInView={{ opacity: 1, y: 0 }}
    //       transition={{ duration: 0.6, delay: 0.2 }}
    //       viewport={{ once: true }}
    //     >
    //       Catapult Media Work is one of the most sought-after event management companies in Chennai, with 1000+ events executed. From concept to completion, we ensure your event runs smoothly while you enjoy every moment.
    //      <div className="section-divider" ></div>
    //     </motion.p>
    //     <div className="why-grid">
    //       {features.map((item, index) => (
    //         <motion.div
    //           className="why-card"
    //           key={index}
    //           initial={{ opacity: 0, y: 40 }}
    //           whileInView={{ opacity: 1, y: 0 }}
    //           transition={{ duration: 0.5, delay: 0.2 * (index + 1) }}
    //           viewport={{ once: true }}
    //         >
    //           <div className="icon">{item.icon}</div>
    //           <h3>{item.title}</h3>
    //           <p>{item.description}</p>
    //         </motion.div>
    //       ))}
    //     </div>
    //   </div>
    // </section>
     <section className="why-catapult" id="why">
      <div className="overlay"></div>
      <div className="container">
        <motion.h2
          className="why-title"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Redefining Customer Experience
        </motion.h2>
        <motion.p
          className="why-intro"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >

         <div className="section-divider" ></div>
        </motion.p>
        {/* <div className="why-grid">
          {features.map((item, index) => (
            <motion.div
              className="why-card"
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 * (index + 1) }}
              viewport={{ once: true }}
            >
              <div className="icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </motion.div>
          ))}
        </div> */}
<Row>
         <Col xs={24} md={12}>
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="whatwedo-content"
            >
              <p style={{ textAlign: "left" }}>
                •  Apart from maintaining the standard of our products, ATE believes in practicing its core ethics.
              </p>
              <p style={{ textAlign: "left" }}>
                • With a down to earth attitude, our team is extremely flexible and approachable. In other words, ATE is never satisfied enhancing its customer experience.
              </p>
            </motion.div>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <motion.div
              // key={index}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="masonry-item"
              whileHover={{ scale: 1.03 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <img src={src1} alt={`Gallery`} loading="lazy" />
            </motion.div>
          </Col>
          </Row>
      </div>
    </section>
  )
}

export default WhyCatapult